import React from 'react'
import {TIMER_FIT_MEDIA} from '../../theme/feltTheme'
import Typography from '@mui/material/Typography'

const NORMAL_COLOR_CLASS = 'normal'
const WARNING_COLOR_CLASS = 'warning'
const DANGER_COLOR_CLASS = 'danger'
const WARNING_PERCENTAGE = 0.3
const DANGER_PERCENTAGE = 0.1

const timeToMinutesSeconds = (timeInSeconds: number) => {
  const minutes = Math.floor(timeInSeconds / 60)
  const seconds = timeInSeconds - minutes * 60
  let duration = ''
  if (minutes >= 10) {
    duration += `${minutes}:`
  } else {
    duration += `0${minutes}:`
  }
  if (seconds >= 10) {
    duration += `${seconds}`
  } else {
    duration += `0${seconds}`
  }
  return duration
}

const determineColorClass = (time: number, danger: number, warning: number) => {
  if (time <= danger) {
    return DANGER_COLOR_CLASS
  } else if (time <= warning) {
    return WARNING_COLOR_CLASS
  }
  return NORMAL_COLOR_CLASS
}


function Countdown({lengthInSeconds, secondsLeftInCurrentSession}: {onCountdownComplete: () => void; lengthInSeconds: number; clockIsRunning: boolean; secondsLeftInCurrentSession: number}) {
  const dangerSeconds = lengthInSeconds * DANGER_PERCENTAGE
  const warningSeconds = lengthInSeconds * WARNING_PERCENTAGE
  const color = determineColorClass(secondsLeftInCurrentSession, dangerSeconds, warningSeconds)
  const countDownDisplay = timeToMinutesSeconds(Math.max(0, secondsLeftInCurrentSession))

  return (
    <Typography role="timer" aria-label="Tournament countdown" sx={theme => ({lineHeight: 1.2, fontSize: `min(30rem, ${200 / countDownDisplay.length}cqw, 32svh)`, [TIMER_FIT_MEDIA]: {fontSize: `min(var(--timer-font-cap, 44rem), ${200 / countDownDisplay.length}cqw, 82cqh)`}, '@supports (text-box-trim: trim-both)': {textBoxTrim: 'trim-both', textBoxEdge: 'cap alphabetic', lineHeight: 1, [TIMER_FIT_MEDIA]: {fontSize: `min(var(--timer-font-cap, 44rem), ${200 / countDownDisplay.length}cqw, 138cqh)`}}, fontWeight: 700, fontVariantNumeric: 'tabular-nums', letterSpacing: '-0.05em', '--timer-normal': theme.palette.text.primary, '--timer-warning': theme.palette.warning.main, '--timer-danger': theme.palette.error.main, color: `var(--timer-${color})`})}>
      {countDownDisplay}
    </Typography>
  )
}

export default Countdown
